"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKvStore = exports.kvStore = exports.kvManager = exports.KeyValueStorageManager = void 0;
var tslib_1 = require("tslib");
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var cached = new Map();
var KeyValueStorageManager = /** @class */ (function () {
    function KeyValueStorageManager() {
        this.Creater = null;
    }
    KeyValueStorageManager.prototype.get = function (storeName, options) {
        if (options === void 0) { options = {}; }
        var skey = "" + storeName + (options.encrypted ? "enctypted" : "") + (options.dbName || "app");
        if (!cached.has(skey)) {
            var instance = void 0;
            if (this.Creater) {
                instance = this.Creater(tslib_1.__assign({ storeName: storeName }, options));
            }
            else {
                instance = di_1.default.tryResolve("kvStorage", [storeName, options.encrypted, options.dbName]);
            }
            cached.set(skey, instance);
        }
        return cached.get(skey);
    };
    return KeyValueStorageManager;
}());
exports.KeyValueStorageManager = KeyValueStorageManager;
exports.kvManager = new KeyValueStorageManager();
/**
 * 获取键值存储对象
 * @deprecated
 * @param storeName
 * @param opts
 */
function kvStore(storeName, opts) {
    if (opts === void 0) { opts = {}; }
    return function (target, propertyKey, desc) {
        var options = {
            get: function () {
                var key = storeName || propertyKey;
                return exports.kvManager.get(key, opts);
            },
            set: function () {
                throw new Error("Not allowed");
            },
            enumerable: true,
            configurable: true,
        };
        if (desc) {
            return options;
        }
        Object.defineProperty(target, propertyKey, options);
    };
}
exports.kvStore = kvStore;
/**
 * 获取用户数据库键值存储对象
 * @deprecated
 * @param storeName
 * @param opts
 */
function useKvStore(storeName, opts) {
    if (opts === void 0) { opts = {}; }
    return exports.kvManager.get(storeName, opts);
}
exports.useKvStore = useKvStore;
exports.default = exports.kvManager;
